module.exports = {
          srcSet: __webpack_public_path__ + "d5940f9da50bd84415dcfdea7ec4b15e-91.png"+" 91w",
          images:[ {path: __webpack_public_path__ + "d5940f9da50bd84415dcfdea7ec4b15e-91.png",width: 91,height: 91}],
          src: __webpack_public_path__ + "d5940f9da50bd84415dcfdea7ec4b15e-91.png",
          toString:function(){return __webpack_public_path__ + "d5940f9da50bd84415dcfdea7ec4b15e-91.png"},
          
          width: 91,
          height: 91
        }